// extracted by mini-css-extract-plugin
export default {"title":"title__e0poF","label":"label__jyH_8","editable":"editable__q_3YU","editIcon":"editIcon__KGUb1","editField":"editField__JqdmP","textInput":"textInput__NnVAR"};